import { updateContract } from "@/requests/contract/update";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Contract } from "@/types/contract";
import { ReactQueryKeys } from "@/constants/common";
import { ContractState } from "@/types/contract";
import { handleMutationError } from "@/utils/error";
import { useIsContractRequest } from "@/hooks/useIsContractRequest";
import { updateRequest } from "@/requests/request/update";

export const useSaveMutation = (uuid: string, onSuccess?: () => void, onError?: () => void) => {
  const isRequest = useIsContractRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (updatedContract: Contract) => {
      return isRequest
        ? updateRequest(uuid, updatedContract, { save: true })
        : updateContract(uuid, updatedContract, { save: true });
    },
    onSuccess: (updatedContract: Contract) => {
      queryClient.setQueryData(ReactQueryKeys.getContract(uuid, isRequest), (oldData: ContractState) => ({
        ...oldData,
        contract: updatedContract,
      }));
      onSuccess?.();
    },
    onError: () => {
      onError?.();
      handleMutationError();
    },
  });
};
